module.exports = __webpack_public_path__ + "static/media/who.2b7a2335.jpg";